import { useQuery } from 'react-query'
import { useParams, useSearchParams } from 'react-router-dom'

import { impactsLibraryService } from 'src/services'

import { QUERY_KEYS } from 'src/constants'

const useLibraryImpact = () => {
  const [searchParams] = useSearchParams()

  const { libraryImpactId } = useParams()
  const libraryDuplicate = searchParams.get('libraryDuplicate')
  const id = libraryImpactId ?? libraryDuplicate

  return useQuery([QUERY_KEYS.GET_LIBRARY_IMPACT, id ?? ''], () => {
    if (!id) return null

    return impactsLibraryService.getLibraryImpactById(id)
  })
}

export { useLibraryImpact }
